import { atom } from 'recoil';

import type { Folder } from '@/api';

export const foldersState = atom<Folder[]>({
  key: 'foldersState',
  default: []
});

// The project (folder) id that new chats should be assigned to
export const pendingProjectIdState = atom<string | null>({
  key: 'pendingProjectIdState',
  default: null
});
